import React from 'react';
import { Plus, UserCheck, FileText, Sparkles } from 'lucide-react';
import { Box, Flex } from 'rebass/styled-components';
import { NavLink, Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Tabs } from '../../../components/atoms/tabs';
import { ContactList } from '../contactList';
import { AddContacts } from '../addContacts';
import { SignupForm } from '../signupForm';
import { AiAgent } from '../aiAgent';

const ContactsLayout = ({ sharedList, activeNetwork, listId }) => {
  const hasSignupForms = activeNetwork.features?.includes('signup_forms');
  const listAgentsEnabled = activeNetwork.features?.includes('list_agents');
  const tabs = [
    {
      id: 'tab-contacts-in-list',
      title: `Contacts · ${sharedList?.contactsCount ?? '0'} `,
      to: `/networks/${activeNetwork.slug}/list/${listId}/contacts`,
      icon: UserCheck,
      show: true,
    },
    {
      id: 'tab-add-contacts',
      title: 'Add contacts',
      to: `/networks/${activeNetwork.slug}/list/${listId}/add-contacts`,
      icon: Plus,
      show: true,
    },
    {
      id: 'tab-ai-agent',
      title: 'AI Agent',
      to: `/networks/${activeNetwork.slug}/list/${listId}/ai-agent`,
      icon: Sparkles,
      show: listAgentsEnabled,
    },
    {
      id: 'tab-signup-form',
      title: 'Signup form',
      to: `/networks/${activeNetwork.slug}/list/${listId}/signup-form`,
      icon: FileText,
      show: hasSignupForms,
    },
  ];

  return (
    <>
      <Box px="16px" pt="8px">
        <Tabs
          tabs={tabs
            .filter(({ show }) => show)
            .map(({ id, title, to, icon }) => (
              <Box as="li" key={id}>
                <Flex
                  data-testid={id}
                  as={NavLink}
                  to={to}
                  sx={{
                    gap: '8px',
                    textDecoration: 'none',
                    alignItems: 'flex-start',
                    fontSize: '14px',
                    lineHeight: '16px',
                    pb: '12px',
                    height: '100%',
                  }}
                >
                  <Box as={icon} size="16px" />
                  <Box>{title}</Box>
                </Flex>
              </Box>
            ))}
        />
      </Box>
      <Box pt="8px" height="100%" sx={{ display: 'flex', flexDirection: 'column' }}>
        <Switch>
          <Route path={`/networks/${activeNetwork.slug}/list/:listId/contacts`}>
            <ContactList sharedList={sharedList} />
          </Route>
          <Route path={`/networks/${activeNetwork.slug}/list/:listId/add-contacts`}>
            <AddContacts sharedList={sharedList} />
          </Route>
          <Route path={`/networks/${activeNetwork.slug}/list/:listId/signup-form`}>
            <SignupForm sharedList={sharedList} listAgentsEnabled={listAgentsEnabled} />
          </Route>
          <Route path={`/networks/${activeNetwork.slug}/list/:listId/ai-agent`}>
            <AiAgent sharedList={sharedList} />
          </Route>
        </Switch>
      </Box>
    </>
  );
};

ContactsLayout.propTypes = {
  sharedList: PropTypes.object.isRequired,
  activeNetwork: PropTypes.object.isRequired,
  listId: PropTypes.string.isRequired,
};

export default ContactsLayout;
